<template>
  <div class="profile-wrap p-3">
    <div class="mb-2">Selamat datang,</div>
    <h2>{{ loggedUser.fullname }}</h2>
    <small>{{ loggedUser.email }}</small>
    <!-- User guide -->
    <div
      class="mt-3 card d-flex align-items-center justify-content-center pointer leading-none"
      @click="openUserGuide()"
    >
      <material-icon name="menu_book" size="20" class="mr-1" /> Baca Panduan
    </div>
    <!-- Go to mental health registration -->
    <div class="card card-success mt-2 text-white">
      <div class="d-flex align-items-center">
        <material-icon name="psychology" type="rounded" size="70" />
        <div>
          <h2 class="mental-health-title mb-1">Layanan Konsultasi Psikologi</h2>
          <button
            class="btn btn-primary btn-rounded btn-sm"
            @click="openMentalHealthHistory"
          >
            Riwayat
          </button>
          <button
            class="btn btn-warning btn-rounded btn-sm"
            @click="openMentalHealthRegistration"
          >
            Daftar
          </button>
        </div>
      </div>
    </div>
    <survey-alert class="mt-2" />
  </div>
</template>

<script>
import SurveyAlert from "../components/SurveyAlert.vue";

export default {
  name: "home",
  components: {
    SurveyAlert,
  },
  data: function () {
    return {
      userGuide: "assets/Panduan-Layanan-HPU.pdf",
    };
  },
  methods: {
    openMentalHealthHistory: function () {
      this.$router.push({ name: "mental-health-history" });
    },
    openMentalHealthRegistration: function () {
      this.$router.push({ name: "mental-health-registration" });
    },
    openUserGuide: function () {
      const url = this.userGuide + "?ts=" + new Date().getTime();
      window.open(url, "_blank");
    },
  },
};
</script>

<style lang="sass" scoped>
.mental-health-title
  @media screen and (max-width: 405px)
    font-size: 18px
  @media screen and (max-width: 365px)
    font-size: 16px
</style>
